// extracted by mini-css-extract-plugin
export default {"container":"CategoryListItem_container__xHifi","link":"CategoryListItem_link__f5p0y","icon":"CategoryListItem_icon__vZddp","label":"CategoryListItem_label__fFBN+"};